module.exports = {"450226100":"古宜镇","450226101":"斗江镇","450226102":"丹洲镇","450226103":"八江镇","450226104":"林溪镇","450226105":"独峒镇","450226203":"同乐苗族乡","450226204":"梅林乡","450226205":"富禄苗族乡","450226206":"洋溪乡","450226207":"良口乡","450226208":"老堡乡","450226209":"高基瑶族乡","450226210":"和平乡","450226211":"程村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450226.json
// module id = 2091
// module chunks = 0